import React, { Component, FormEvent, ChangeEvent } from 'react'
import { Link, useHistory } from 'react-router-dom'
import classnames from 'classnames'
import {
    Card,
    CardBody,
    CardHeader,
    Button,
    Input,
    Form,
    Row,
    Col,
    Container,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
} from 'reactstrap'

import { withFirebase } from '../../components/Firebase'
import * as ROUTES from '../../constants/routes'

const PasswordForgetPage = () => {
    const history = useHistory();
    
    const handleClose = () => {
        history.push(ROUTES.SIGN_IN);
    };

    return (
        <div className="wrapper">
            <Container>
                <Row>
                    <Col className="mx-auto" lg="5" md="12">
                        <Card className="text-center modal-style">
                            <button onClick={handleClose} className="close-button">
                                ×
                            </button>
                            <CardHeader>
                                <h4 className="modal-title">Password Forget</h4>
                            </CardHeader>
                            <PasswordForgetForm />
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

class PasswordForgetFormBase extends Component<PasswordForgetProps, PasswordForgetState> {
    constructor(props: PasswordForgetProps) {
        super(props);
        this.state = { ...INITIAL_STATE, showSuccess: false };
    }

    onSubmit = (event: FormEvent<HTMLFormElement>) => {
        const { email } = this.state;
        this.props.firebase
            .doPasswordReset(email)
            .then(() => {
                this.setState({ ...INITIAL_STATE, showSuccess: true });
                setTimeout(() => {
                  this.setState({ showSuccess: false });
                }, 3000);
            })
            .catch((error: Error) => {
                this.setState({ error });
            });
        event.preventDefault();
    };

    onChange = (event: ChangeEvent<HTMLInputElement>) => {
        this.setState({ [event.target.name]: event.target.value } as any);
    };

    render() {
        const { email, error, showSuccess } = this.state;
        const isInvalid = email === '';

        return (
            <CardBody>
                <div className="account-input-narrow">
                    <h4 className="mb-3">Reset My Password</h4>
                    {showSuccess && (
                      <div className="alert alert-success text-center" role="alert" style={{marginBottom: '16px'}}>
                        Email sent! Please check your inbox.
                      </div>
                    )}
                    <Form onSubmit={this.onSubmit}>
                        <InputGroup
                            className={classnames({
                                "input-group-focus": this.state.emailFocus
                            })}
                        >
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                    <i className="tim-icons icon-email-85" />
                                </InputGroupText>
                            </InputGroupAddon>
                            <Input
                                name="email"
                                value={this.state.email}
                                onChange={this.onChange}
                                type="text"
                                placeholder="Email Address"
                                onFocus={() => this.setState({ emailFocus: true })}
                                onBlur={() => this.setState({ emailFocus: false })}
                            />
                        </InputGroup>
                        <Button
                            className="btn-info-custom mt-3"
                            size="lg"
                            disabled={isInvalid}
                            type="submit"
                        >
                            <span>Reset My Password</span>
                        </Button>
                        {error && <p className="text-warning pt-2">{error.message}</p>}
                    </Form>
                </div>
            </CardBody>
        );
    }
}

type PasswordForgetProps = {
    firebase: any
}

type PasswordForgetState = {
    email: string,
    error: any | null,
    emailFocus: boolean,
    showSuccess?: boolean
}

const INITIAL_STATE: PasswordForgetState = {
    email: '',
    error: null,
    emailFocus: false
};

const PasswordForgetLink = () => (
    <p className="text-center pb-2">
        <Link to={ROUTES.PASSWORD_FORGET} className="accent-link">Forgot Password?</Link>
    </p>
);

export default PasswordForgetPage;
const PasswordForgetForm = withFirebase(PasswordForgetFormBase);
export { PasswordForgetForm, PasswordForgetLink };